<template>
  <div>
    <div v-if="isDebug">
      <div>
        <div class="col-xs-4">regressionTitle</div>
        <div class="col-xs-8">{{ regressionTitle() }}</div>
      </div>
      <div>
        <div class="col-xs-4">xlsxTitle</div>
        <div class="col-xs-8">{{ xlsxTitle() }}</div>
      </div>
    </div>
    <section-header ref="selectHeader" title="Select Location"></section-header>
    <location-selection labeledBy="selectionHeader"></location-selection>
    <app-navigator
      ref="appNavigator"
      :router="$router"
      nextButtonTitle="Select one or more locations to continue"
    ></app-navigator>
  </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import locationSelection from "@/components/locationSelection";
import current from "@/scripts/current";
import commonModelHelper from "@/scripts/commonModelHelper";
import store from "@/store";
import sectionHeader from "@/components/sub/sectionHeader";
import appNavigator from "@/components/layout/appNavigator";

export default {
  components: {
    locationSelection,
    sectionHeader,
    appNavigator,
  },
  data: function () {
    let vm = this;
    current.initializeCrossTabulationValues(vm);
    commonModelHelper.initializeStep(vm, "location");
    return {
      isDebug: false,
    };
  },
  methods: {
    regressionTitle: function () {
      return commonModelHelper.getReportTitleLocations(
        store.state.selModel.locations
      );
    },
    xlsxTitle: function () {
      return commonModelHelper.getLocationsForXlsx(
        store.state.selModel.locations
      );
    },
  },
};
</script>

<style scoped="">
</style>
